import 'core-js/fn/array/from';
import 'gsap/TweenLite';
import './utils/Element';
import './utils/polyfill/element-closest';
import './utils/polyfill/promise';
import './utils/polyfill/fetch';
import './utils/HTMLCollection';
import './utils/LocalStorage';

import settings from './settings';
import mitt from 'mitt';
import throttle from 'lodash/throttle';

function init() {
  setupEvents();
  initComponents();
}

function initComponents() {
  settings.forEach(setting => {
    Array.from(document.querySelectorAll(setting.selector)).forEach(node => {
      new setting.component(node);
    })
  })
}

function setupEvents() {
  window.events = mitt();
  window.addEventListener('resize', handleResize);
}

const handleResize = throttle(() => {
  events.emit('resize');
}, 150);

init();


// WEBPACK FOOTER //
// frontend/js/index.js